import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import useStateRef from 'react-usestateref';
import { updateShoppingListDetailsAction } from '../../middleware/updateShoppingListDetailsAction';

const ImportShoppingListModal = (props) => {


    const [addShoppingListResponse, setAddShoppingListResponse, addShoppingListResponseRef] = useStateRef("")
    const [importError, setImportError, importErrorRef] = useStateRef("")
    const history = useHistory();
    const dispatch = useDispatch();
    const formRef = useRef(null);

    const handleSubmit = (event) => {
        event.preventDefault();
        // setIsLoading(false)
        // setHasError(false)
        var actionUrl = event.target.getAttribute('action');
        var searchParam = window.location.search;
        let params = new URLSearchParams(searchParam);
        let id = params.get("giftlistId");
        var formData = new FormData(event.target);
        formData.append("giftlistId", id)
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/${actionUrl}`, {
            credentials: "include",
            method: "POST",
            enctype: "multipart/form-data",
            body: formData
        }).then(res => res.json())
            .then(res => {
                console.log("res", res);


                if (res.result == "success") {
                    var shoppingListSuccessDetatils = res.response;
                    setAddShoppingListResponse(shoppingListSuccessDetatils);
                    dispatch(updateShoppingListDetailsAction(true));
                    formRef.current.reset();
                    document.getElementById("closeImportListModal").click();
                    props.handleSuceesModalTrigger(true)

                } else {
                    formRef.current.reset();
                    setImportError(res.response.message?res.response.message:"")
                }
            })
    }



    useEffect(()=>{
        document.querySelector('#importListModal').addEventListener('hidden.bs.modal', function (e) {
            setImportError()
        })
    },[])
    return (
        <div>


            <div className="modal fade" id="importListModal" tabindex="-1" aria-labelledby="importListModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-md">
                    <div className="modal-content p-4">

                        {importErrorRef.current ?
                            <div className="col-12 mt-2">
                                <div className="alert alert-danger d-block" role="alert" id="importShoppingListError">
                                    <p>{importErrorRef.current}</p>
                                </div>
                            </div> : ""}
                            <div className="c-modal importShoppingList custom-modal-header">
                            <h3 className="modal-title" id="importListModalLabel">Import [Users/Items]</h3>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeImportListModal"></button>
                        </div>
                        <div className="modal-body px-0 py-2 custom-modal-body mx-1">

                            <form method="post" action="import-list" onSubmit={handleSubmit} id="fileUpload" className="col-12" ref={formRef}>

                                <div className="container-fluid c-modal importList-modal-body">
                                    <div className="row">
                                        <div className="col-12 px-0">
                                            <p className="modal-para">
                                                Follow the steps below to import multiple products using an Microsoft® Excel spreadsheet.
                                            </p>
                                        </div>
                                        <div className="col-12 px-0">

                                            <h4 className="modal-sub-heading">1. Download the Template and Enter Data</h4>
                                            <p className="download-para">
                                                <a className="fwb" href="/document/list-import-template.xls">Click here to download the Microsoft® Excel template</a> and fill in the required information for each product you wish to add.
                                            </p>

                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-12">
                                                <label for="formFile" className="form-label modal-sub-heading">2. Select and Upload Completed File</label>
                                            </div>
                                            <div className="col-12">
                                                <input name="listFile" type="file" className="file-input" />
                                            </div>
                                        </div>
                                        <div className="row justify-content-end form-submit">
                                            <div className="col-auto">
                                                <input name="fileUploadHandler" id="subUpload" type="submit" value="Upload File" className="col-auto btn btn-primary" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>





            <p id="importshoppingSuccesId" aria-current="page" data-bs-toggle="modal" data-bs-target="#importshoppingSuccesModal"></p>
            <div className="modal gx-0 fade c-modal c-shopping-list-modal-body" id="importshoppingSuccesModal" tabindex="-1" aria-labelledby="shoppingListSuccess" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-md modal-lg-a">
                    <div className="modal-content">
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeImportListModal"></button>
                        <div className="modal-body">
                            <div className="container-fluid addedToList-modal-body">
                                <div className="row">
                                    <div className="col-12">
                                        <h3 className="modal-title" id="defaultModalLabel">Added to List</h3>
                                    </div>
                                    <div className="col-12 mb-3 text-end d-none d-md-block">
                                        <button className="btn btn-primary mx-1" data-bs-dismiss="modal">Continue Shopping</button>
                                        <button className="btn btn-primary" data-bs-dismiss="modal" onClick={() => history.push("/account/list")}>Go to Shopping Lists</button>
                                    </div>
                                    {addShoppingListResponseRef.current && addShoppingListResponseRef.current.response && addShoppingListResponseRef.current.response.validproducts && addShoppingListResponseRef.current.response.validproducts.length > 0 ?
                                        <ul className="col-12 list-unstyled addedToList-items">
                                            <div className="alert alert-success my-0 d-block" role="alert">
                                                <p className="fwb">The following products were added to your list(s):</p>
                                            </div>
                                            {addShoppingListResponseRef.current ? addShoppingListResponseRef.current.response.validproducts.map((value) => {
                                                return (<>
                                                    <li className="addToList-item">
                                                        <div className="row">
                                                            <div className="col-10 col-md-2 list-sku">Item #&nbsp;{value.ProductId ? value.ProductId : ""}</div>
                                                            <div className="col-10 order-3 order-md-2 col-md-8 list-title" dangerouslySetInnerHTML={{ __html: value.productName ? value.productName : "" }}></div>
                                                            <div className="col-2 order-2 order-md-3 item-qty text-center">Qty:&nbsp;{value.Quantity ? value.Quantity : ""}</div>
                                                        </div>
                                                    </li>
                                                </>)
                                            }) : ""}
                                        </ul> : ""}

                                    {addShoppingListResponseRef.current && addShoppingListResponseRef.current.response && addShoppingListResponseRef.current.response.invalidProducts && addShoppingListResponseRef.current.response.invalidProducts.length > 0 ?
                                        <>
                                            <div className="alert message message-red d-block" role="alert">
                                                <p className="fwb">We were unable to add the following items to your list(s):</p>
                                            </div>
                                            <ul className="col-12 list-unstyled addedToList-items">
                                                {addShoppingListResponseRef.current ? addShoppingListResponseRef.current.response.invalidProducts.map((value) => {
                                                    return (<>
                                                        <li className="addToList-item">
                                                            <div className="row">
                                                                <div className="col-10 col-md-2 list-sku">Item #&nbsp;{value.ProductId ? value.ProductId : ""}</div>
                                                                <div className="col-10 order-3 order-md-2 col-md-8 list-title" dangerouslySetInnerHTML={{ __html: value.productName ? value.productName : "" }}></div>

                                                            </div>
                                                        </li>
                                                    </>)
                                                }) : ""}
                                            </ul>
                                        </>
                                        : ""}



                                    <div className="col-12 mb-3 text-end">
                                        <button className="btn btn-primary mx-1" data-bs-dismiss="modal">Continue Shopping</button>
                                        <button className="btn btn-primary" data-bs-dismiss="modal" onClick={() => history.push("/account/list")} >Go to Shopping Lists</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ImportShoppingListModal